module.exports = __webpack_public_path__ + "static/media/dashboard-icon.0ea67ef4.svg";